import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import ToolbarIconButton from 'components/consumer/ToolbarIconButton';
import Link from 'components/consumer/Link';
import useUserData from 'data-hooks/useUserData';
import DropdownItem from './DropdownItem';
const HeaderToolbarDropdown = t0 => {
  const $ = _c(23);
  const {
    icon,
    title: t1,
    dropdownItems: t2,
    children,
    iconClassName: t3,
    "data-xc": t4
  } = t0;
  const title = t1 === undefined ? "" : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const dropdownItems = t5;
  const iconClassName = t3 === undefined ? "" : t3;
  const dataXc = t4 === undefined ? "" : t4;
  const {
    isLoggedIn
  } = useUserData();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownContainerRef = useRef(null);
  let t6;
  if ($[2] !== isDropdownOpen) {
    t6 = () => {
      setIsDropdownOpen(!isDropdownOpen);
    };
    $[2] = isDropdownOpen;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const onDropdownButtonClick = t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const handleClickOutside = t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = event_0 => {
      if (event_0.target instanceof Element && event_0.target.closest("a")) {
        setIsDropdownOpen(false);
      }
    };
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const handleDropdownContentClick = t8;
  let t10;
  let t9;
  if ($[6] !== isDropdownOpen) {
    t9 = () => {
      if (!isDropdownOpen) {
        return;
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t10 = [isDropdownOpen, handleClickOutside];
    $[6] = isDropdownOpen;
    $[7] = t10;
    $[8] = t9;
  } else {
    t10 = $[7];
    t9 = $[8];
  }
  useEffect(t9, t10);
  const t11 = `max-[1023px]:hidden ${iconClassName}`;
  let t12;
  if ($[9] !== dataXc || $[10] !== icon || $[11] !== onDropdownButtonClick || $[12] !== t11 || $[13] !== title) {
    t12 = <ToolbarIconButton data-xc={dataXc} icon={icon} onClick={onDropdownButtonClick} title={title} className={t11} />;
    $[9] = dataXc;
    $[10] = icon;
    $[11] = onDropdownButtonClick;
    $[12] = t11;
    $[13] = title;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== children || $[16] !== dropdownItems || $[17] !== isDropdownOpen || $[18] !== isLoggedIn) {
    t13 = isDropdownOpen && <div className="absolute min-w-[8rem] top-12 right-0 bg-white border border-gray-light5" onClick={handleDropdownContentClick}>{children || dropdownItems?.map((item, index) => {
        const targetLink = isLoggedIn && item?.loggedInLink ? item?.loggedInLink : item?.link;
        return item?.link ? <Link to={targetLink} key={item?.text} className="background:none] border-0 focus-visible:outline-offset-4 hover:text-brand hover:underline"><DropdownItem isLoggedIn={isLoggedIn} item={item} index={index} /></Link> : item?.onClick ? <div onClick={item?.onClick} role="button" tabIndex={0} key={item?.text}><DropdownItem item={item} index={index} /></div> : <DropdownItem item={item} index={index} key={item?.text} />;
      })}</div>;
    $[15] = children;
    $[16] = dropdownItems;
    $[17] = isDropdownOpen;
    $[18] = isLoggedIn;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <div ref={dropdownContainerRef} className="relative">{t12}{t13}</div>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};
HeaderToolbarDropdown.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  dropdownItems: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  iconClassName: PropTypes.string,
  'data-xc': PropTypes.string
};
export default HeaderToolbarDropdown;